import { combineReducers } from "redux-immutable";

import MemoriesStateSlice from "../models/MemoriesStateSlice";

import memories from "./state/memories";
import memoriesMetaReducer from "./state/meta";

const memoryReducer = combineReducers(
  {
    memories,
    meta: memoriesMetaReducer
  },
  () => new MemoriesStateSlice() as any
);

export default memoryReducer;
